import { registerPlugin } from "@capacitor/core";

export const PlayAlternativeBillingNative = registerPlugin(
    "PlayAlternativeBilling"
);
